import jwtAxios from "@richbeauty/services/auth/jwt-auth/jwt-api";
import useSWRMutation from "swr/mutation";
const postDeal = async (deal) => await jwtAxios.post("cms-deals", deal);

const usePostDeal = () => {
  const fetcher = (url, { arg }) => postDeal(arg);
  return useSWRMutation("cms-deals", fetcher);
};
export default usePostDeal;
